import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { CallApi } from "../statics.js";
import {
  RightOutlined,
  ShoppingCartOutlined,
  CaretLeftOutlined,
  CheckOutlined,
  DeleteOutlined,
  FormOutlined,
  InfoCircleOutlined,
  PrinterOutlined,
} from "@ant-design/icons";
// import { useStore } from "../store";
import {
  Skeleton,
  Button,
  Typography,
  Statistic,
  Table,
  Space,
  Divider,
  Tooltip,
  Spin,
  Pagination,
  Input,
  ConfigProvider,
} from "antd";
import logo from "../images/logo120.png";
import "./print.module.css";
import { v4 as uuidv4 } from "uuid";

const { Text } = Typography;
const { TextArea } = Input;

export default function OrderDetails() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalSquare, setTotalSquare] = useState(0);
  const [descrValue, setDescrValue] = useState("");
  const [finalPrice, setFinalPrice] = useState(0);
  const [discountPercentage, setDiscountPercentage] = useState(0);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [apiDiscountInfo, setApiDiscountInfo] = useState(null);
  const [shopItemClasses, setShopItemClasses] = useState([]);

  const shopItemRefs = useRef([]);
  const itemsResultRefs = useRef([]);

  const [columns, setColumns] = useState([
    {
      title: "شماره",
      key: "index",
      render: (text, record, index) => (
        <span className="text-neutral-400">{index + 1}</span>
      ),
    },
    {
      title: "ارتفاع(میلی‌متر)",
      dataIndex: "height",
      key: "height",
      render: (text) => (
        <Statistic
          valueStyle={{
            fontSize: "inherit",
            color: "inherit",
          }}
          value={text}
        />
      ),
    },
    {
      title: "عرض(میلی‌متر)",
      dataIndex: "width",
      key: "width",
      render: (text) => (
        <Statistic
          valueStyle={{
            fontSize: "inherit",
            color: "inherit",
          }}
          value={text}
        />
      ),
    },

    {
      title: "مدل",
      dataIndex: "model",
      key: "model",
      render: (_, { wideObject }) => {
        let text = "";
        if (wideObject.modelObj && wideObject.modelObj.title)
          text = wideObject.modelObj.title;

        return text ? text : "-";
      },
    },
    {
      title: "موارد اضافی",
      dataIndex: "additional",
      key: "additional",
      render: (_, { wideObject }) => {
        let additionalItemList = JSON.parse(JSON.stringify(wideObject));
        // additionalItemList = additionalItemList.additionalItemList.filter(
        //   (it) => it.isEnd
        // );
        additionalItemList = additionalItemList.additionalItemList.filter(
          (it) => {
            if (it.isEnd) return true;
            else {
              let found = false;
              additionalItemList.additionalItemList.forEach((element) => {
                if (element.parentId === it._id && element.isEnd) found = true;
              });

              return found;
            }
          }
        );
        // console.log(additionalItemList);

        let test = [];
        additionalItemList.forEach((element) => {
          if (
            !element.isEnd &&
            element.priceFormulaParams.length < 1 &&
            element.stepItemObj.length < 1
          ) {
            let t = JSON.parse(JSON.stringify(element));
            t.myChild = additionalItemList.filter(
              (it) =>
                it.parentId === element._id &&
                it.isEnd &&
                it.priceFormulaParams.length < 1 &&
                it.stepItemObj.length < 1
            );

            if (t.myChild.length > 0) test.push(t);
          } else if (
            element.isEnd &&
            (element.priceFormulaParams.length > 0 ||
              element.stepItemObj.length > 0)
          )
            test.push(element);
        });

        let text = "";
        test.forEach((element) => {
          if (element.priceFormulaParams.length > 0) {
            if (text === "") text = element.title;
            else text += " , " + element.title;
            text += " (";
            let paramsText = "";
            element.priceFormulaParams.forEach((element1) => {
              if (paramsText === "")
                paramsText = element1.key + ": " + element1.value;
              else paramsText += "," + element1.key + ": " + element1.value;
            });
            text += paramsText + ")";
          } else if (element.stepItemObj.length > 0) {
            if (text === "")
              text = element.title + " (" + element.stepItemObj[0].title + ")";
            else
              text +=
                " , " +
                element.title +
                " (" +
                element.stepItemObj[0].title +
                ")";
          } else {
            if (text === "") text = element.title;
            else text += " , " + element.title;
            if (element.myChild && element.myChild.length > 0) {
              text += " (";
              let paramsText = "";
              element.myChild.forEach((element1) => {
                if (element.childType === "parameters") {
                  if (paramsText === "")
                    paramsText = element1.title + ": " + element1.value;
                  else
                    paramsText +=
                      " , " + element1.title + ": " + element1.value;
                } else {
                  if (paramsText === "") paramsText = element1.title;
                  else paramsText += "," + element1.title;
                }
              });
              text += paramsText + ")";
            }
          }
        });

        return <span>&rlm;‎{text ? text : "-"}&rlm;‎</span>;
      },
    },
    {
      title: "جزئیات",
      dataIndex: "detail",
      key: "detail",
      render: (_, { wideObject }) => {
        let detail = "";
        wideObject.detailItemList.forEach((element) => {
          if (detail === "")
            detail =
              element.title +
              " (" +
              element.code +
              "-" +
              element.dimention.code +
              ")";
          else
            detail +=
              " , " +
              element.title +
              " (" +
              element.code +
              "-" +
              element.dimention.code +
              ")";
        });
        // if (detail !== "") detail += ")";
        return <span>&rlm;‎{detail ? detail : "-"}&rlm;‎</span>;
      },
    },
    {
      title: "مساحت(مترمربع)",
      dataIndex: "meterage",
      key: "meterage",
      render: (text) => (
        <Statistic
          valueStyle={{
            fontSize: "inherit",
            color: "inherit",
          }}
          value={text}
        />
      ),
    },
    {
      title: "تعداد",
      dataIndex: "quantity",
      key: "quantity",
    },
    {
      title: "مبلغ واحد (ریال)",
      dataIndex: "price",
      key: "price",
      render: (_, { price, quantity }) => (
        <Statistic
          valueStyle={{
            fontSize: "inherit",
            color: "inherit",
          }}
          value={(Number(price) / quantity).toFixed().toString()}
        />
      ),
    },
    {
      title: "مبلغ کل (ریال)",
      dataIndex: "price",
      key: "price",
      render: (text) => (
        <Statistic
          valueStyle={{
            fontSize: "inherit",
            color: "inherit",
          }}
          value={Number(text).toFixed().toString()}
        />
      ),
    },
  ]);

  let { orderId } = useParams();

  const navigate = useNavigate();

  // const changeBreadcrumbArray = useStore(
  //   (state) => state.changeBreadcrumbArray
  // );

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    getOrderItems();
    document.body.style.fontFamily = "BYekan";

    return () => {
      document.body.style.fontFamily = "";
    };
  }, []);

  const getOrderItems = () => {
    let body = {
      username: getCookie("username"),
      token: getCookie("token"),
      orderId: orderId,
    };
    console.log(body);
    setLoading(true);
    CallApi("getOrderItems", "post", body)
      .then((result) => {
        console.log(result);
        setLoading(false);
        if (result.status === 200) {
          let allOrders = [];

          result.orderList.forEach((element) => {
            let found = false;
            allOrders.forEach((element1) => {
              if (
                JSON.stringify(element.BCList) ===
                JSON.stringify(element1.BCList)
              ) {
                found = true;
                element1.childs.push({
                  width: element.width,
                  height: element.height,
                  price: element.price,
                  meterage: element.totalMeterage,
                  quantity: element.quantity,
                  wideObject: element.wideObject,
                  lineParam: element.lineParam,
                  orderParams: element.orderParams,
                  key: uuidv4(),
                });
              }
            });
            if (!found) {
              let childs = [];
              childs.push({
                width: element.width,
                height: element.height,
                price: element.price,
                meterage: element.totalMeterage,
                quantity: element.quantity,
                wideObject: element.wideObject,
                lineParam: element.lineParam,
                orderParams: element.orderParams,
                key: uuidv4(),
              });
              let order = {
                BCList: element.BCList,
                childs: childs,
                createdAt: result.orderList[0].createdAt,
                orderId: result.orderList[0].orderId,
                customerName: result.customerName,
                customerMobile: result.customerMobile,
              };
              allOrders.push(order);
            }
          });

          allOrders.forEach((element) => {
            let totalPrice = 0;
            let totalMeterage = 0;
            element.childs.forEach((element1) => {
              totalPrice += element1.price;
              totalMeterage += element1.meterage;
            });
            element.totalPrice = totalPrice;
            element.totalSquare = totalMeterage;
          });

          console.log(allOrders);

          setDescrValue(result.descr);

          // ذخیره اطلاعات تخفیف از API
          if (
            result.finalPrice &&
            result.totalPrice &&
            result.discount_percentage
          ) {
            setApiDiscountInfo({
              finalPrice: result.finalPrice,
              totalPrice: result.totalPrice,
              discountPercentage: result.discount_percentage,
            });
          }

          setData(allOrders);
        } else if (result.status === 401) {
          navigate("/");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    let total = 0;
    let square = 0;
    data.forEach((element) => {
      element.childs.forEach((element1) => {
        total += element1.price;
        square += element1.meterage;
      });
    });

    setTotalPrice(total);
    setTotalSquare(square);

    const checkDivsHeight = () => {
      const newClasses = data.map((item, index) => {
        if (
          shopItemRefs.current[index] &&
          shopItemRefs.current[index].offsetHeight > 720
        ) {
          return "page-not-break";
        }
        return "page-break";
      });
      setShopItemClasses(newClasses);
    };

    checkDivsHeight();
    window.addEventListener("resize", checkDivsHeight);

    return () => {
      window.removeEventListener("resize", checkDivsHeight);
    };
  }, [data]);

  // تنظیم اطلاعات تخفیف بعد از محاسبه totalPrice
  useEffect(() => {
    if (apiDiscountInfo) {
      // اگر API اطلاعات تخفیف را ارسال کرده باشد، از آن استفاده کن
      setFinalPrice(apiDiscountInfo.finalPrice);
      setDiscountPercentage(apiDiscountInfo.discountPercentage);
      setDiscountAmount(
        apiDiscountInfo.totalPrice - apiDiscountInfo.finalPrice
      );
    } else {
      // در غیر این صورت، finalPrice برابر totalPrice خواهد بود
      setFinalPrice(totalPrice);
      setDiscountPercentage(0);
      setDiscountAmount(0);
    }
  }, [apiDiscountInfo, totalPrice]);

  const onBackClick = () => {
    navigate("/receivedorders");
  };

  const onPrintClick = () => {
    window.print();
    // var header_str =
    //   "<html dir=rtl><head><title>" + document.title + "</title></head><body>";
    // var footer_str = "</body></html>";
    // var new_str = document.getElementById("section-to-print").innerHTML;
    // var old_str = document.body.innerHTML;
    // document.body.innerHTML = header_str + new_str + footer_str;
    // window.print();
    // document.body.innerHTML = old_str;
    // return false;
  };

  return (
    <div className="w-full flex justify-center font-byekan bg-white" dir="rtl">
      <div className="w-full flex flex-col justify-center items-stretch p-4 gap-4 overflow-auto">
        {!loading && (
          <div className="w-full flex justify-center" id="non-printable">
            <div className="w-full pb-0 flex flex-row gap-3">
              <Button
                className="items-center flex font-byekan"
                // type="primary"
                shape="round"
                size="large"
                icon={<RightOutlined />}
                onClick={onBackClick}
              >
                <div className="hidden sm:inline-block">بازگشت</div>
              </Button>
              <Button
                className="items-center flex font-byekan"
                type="primary"
                color="default"
                variant="solid"
                shape="round"
                size="large"
                icon={<PrinterOutlined />}
                onClick={onPrintClick}
              >
                <div className="hidden sm:inline-block">چاپ</div>
              </Button>
            </div>
          </div>
        )}

        {!loading && (
          <img
            src={logo}
            alt="logo"
            className="absolute print:left-1/2 print:-translate-x-1/2 left-5 top-6 w-28"
          />
        )}
        {!loading && (
          <div className="!inline-block" id="section-to-print">
            <div className="w-full flex flex-col gap-3 print:mt-16">
              <div className="flex-1 flex flex-col gap-3 border-[1px] border-black border-solid rounded-lg p-4">
                {data.length > 0 && (
                  <div className="flex flex-row justify-between">
                    <div className="flex flex-row gap-2 text-black text-xs sm:text-lg items-end">
                      <div>نام مشتری: </div>
                      <div>{data[0].customerName}</div>
                    </div>
                    <div className="flex flex-row gap-2 text-black text-xs sm:text-lg items-end">
                      <div>موبایل: </div>
                      <div>{data[0].customerMobile}</div>
                    </div>
                  </div>
                )}
                {data.length > 0 && (
                  <div className="flex flex-row justify-between">
                    <div className="flex flex-row gap-2 text-black text-xs sm:text-lg items-end">
                      <div>شماره سفارش: </div>
                      <div>{data[0].orderId}</div>
                    </div>
                    <div className="flex flex-row gap-2 text-black text-xs sm:text-lg items-end">
                      <div>&rlm;‎{data[0].createdAt.split(" ")[1]}&rlm;‎</div>-
                      <div>&rlm;‎{data[0].createdAt.split(" ")[0]}&rlm;‎</div>
                    </div>
                  </div>
                )}
              </div>
              {data.map((item, i) => {
                return (
                  <div
                    key={i}
                    ref={(el) => (shopItemRefs.current[i] = el)}
                    className={`inline-block ${shopItemClasses[i]}`}
                  >
                    <div className="border-[1px] border-solid border-neutral-500 flex flex-col gap-3 p-4 rounded-lg !h-fit">
                      <div className="flex flex-row justify-between items-center gap-3">
                        <div className="flex flex-row items-center mt-0 sm:mt-4 mb-2 gap-2">
                          <span className="leading-8">
                            {item.BCList.map((el, ii) => {
                              return (
                                <span
                                  key={ii}
                                  className="text-sm sm:text-xl text-neutral-800"
                                >
                                  &rlm;‎{el.title}
                                  {ii < item.BCList.length - 1 && (
                                    <CaretLeftOutlined className="mx-2 text-inherit" />
                                  )}
                                  &rlm;‎
                                </span>
                              );
                            })}
                          </span>
                        </div>
                      </div>
                      <div
                        className="overflow-x-auto inline-block"
                        // id="non-printable1"
                      >
                        <Table
                          columns={columns}
                          dataSource={item.childs}
                          pagination={false}
                          //   scroll={{
                          //     x: 1200,
                          //   }}
                          className="flex-1 font-byekan"
                        />
                      </div>

                      <div className="flex-1">
                        <div className="flex flex-col sm:flex-row gap-4 items-center justify-end font-byekan">
                          <div className="flex flex-row gap-2 items-center">
                            <Text className=" !text-neutral-800 text-xs sm:text-sm m-0 font-byekan">
                              جمع مساحت:
                            </Text>

                            <div className="flex flex-row gap-1 items-center text-xs text-black font-byekan">
                              <Statistic
                                valueStyle={{
                                  fontSize: "14px",
                                  color: "black",
                                }}
                                // value={item.totalSquare}
                                value={Number(item.totalSquare.toFixed(3))}
                              />
                              مترمربع
                            </div>
                          </div>
                          <Divider
                            type="vertical"
                            className="bg-neutral-800 m-0 hidden sm:m-0 sm:visible"
                          />
                          <div className="flex flex-row gap-2 items-center">
                            <Text className=" !text-neutral-800 text-xs sm:text-sm m-0">
                              جمع مبلغ:
                            </Text>

                            <div className="flex flex-row gap-1 items-center text-sm text-black font-byekan">
                              <Statistic
                                valueStyle={{
                                  fontSize: "14px",
                                  color: "black",
                                }}
                                value={item.totalPrice.toFixed()}
                              />
                              ریال
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

              {data.length > 0 && (
                <div
                  ref={itemsResultRefs}
                  className={`!inline-block ${
                    itemsResultRefs &&
                    itemsResultRefs.current &&
                    itemsResultRefs.current.offsetHeight > 500
                      ? "page-not-break"
                      : "page-break"
                  }`}
                >
                  <div className="flex flex-col gap-3">
                    <div className="flex flex-col items-center sm:flex-row sm:items-start sm:gap-2 justify-between gap-6 p-4 rounded-xl border-[1px] border-solid  border-neutral-800">
                      {descrValue && (
                        <div className="w-full sm:w-1/2 flex flex-col text-black gap-2 text-sm sm:text-lg">
                          <div>توضیحات</div>
                          <div className="whitespace-pre-line text-black border-black text-xs sm:text-sm border border-solid p-3 rounded-md">
                            {descrValue}
                          </div>
                        </div>
                      )}
                      <div className="flex flex-col gap-4">
                        <div className="flex flex-row gap-2 items-center">
                          <Text className=" !text-neutral-800 text-sm sm:text-lg m-0 font-byekan">
                            جمع مساحت کل:
                          </Text>

                          <div className="flex flex-row gap-1 items-center text-sm sm:text-lg text-black font-byekan">
                            <Statistic
                              valueStyle={{
                                fontSize: "!inherit",
                                color: "black",
                              }}
                              value={Number(totalSquare.toFixed(3))}
                            />
                            مترمربع
                          </div>
                        </div>
                        <div className="flex flex-row gap-2 items-center">
                          <Text className=" !text-neutral-800 text-sm sm:text-lg font-byekan">
                            جمع کل سفارش:
                          </Text>

                          <div className="flex flex-row gap-1 items-center !text-sm sm:!text-lg text-black font-byekan">
                            <Statistic
                              valueStyle={{
                                fontSize: "!inherit",
                                color: "black",
                              }}
                              value={totalPrice.toFixed()}
                            />
                            ریال
                          </div>
                        </div>
                        {discountPercentage > 0 && discountAmount > 0 && (
                          <>
                            <div className="flex flex-row gap-2 items-center">
                              <Text className=" !text-neutral-800 text-sm sm:text-lg font-byekan">
                                تخفیف ({discountPercentage}%):
                              </Text>

                              <div className="flex flex-row gap-1 items-center !text-sm sm:!text-lg text-black font-byekan">
                                <Statistic
                                  valueStyle={{
                                    fontSize: "!inherit",
                                    color: "#000",
                                  }}
                                  value={discountAmount.toFixed()}
                                />
                                ریال
                              </div>
                            </div>
                            <div className="flex flex-row gap-2 items-center">
                              <Text className=" !text-neutral-800 text-sm sm:text-lg font-bold font-byekan">
                                مبلغ نهایی:
                              </Text>

                              <div className="flex flex-row gap-1 items-center !text-sm sm:!text-lg text-black font-bold font-byekan">
                                <Statistic
                                  valueStyle={{
                                    fontSize: "!inherit",
                                    color: "black",
                                    fontWeight: "bold",
                                  }}
                                  value={finalPrice.toFixed()}
                                />
                                ریال
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {loading && (
          <div className="h-[40vh] w-full flex justify-center items-center">
            <Spin size="large" />
          </div>
        )}
      </div>
    </div>
  );
}
